import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Select } from 'common-src/components/base';
import Patient, {
  getPatientCmsData,
  updatePatient,
  validatePatient,
} from 'common-src/models/Patient';
import {
  CmsReferralSourceOptions,
  NursingHomeStatusOptions,
  ResidenceTypeOptions,
} from 'common-src/models/PatientGuideCmsAlignment';

import useAlert from 'src/hooks/useAlert';
import useFormButtons from 'src/hooks/useFormButtons';
import styles from 'src/pages/PatientDetails/fragments/KnownPlans/forms/PatientDemographics/PatientDemographics.module.scss';

const CmsAlignment = ({ patient }) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({});

  const { showAlert, AlertType } = useAlert();

  const onSubmitHandler = (setIsLoading, setIsEditMode) => {
    setIsLoading(true);
    dispatch(
      updatePatient(
        patient.id,
        { ...formData },
        {
          successBlock: () => {
            setIsEditMode(false);
            setIsLoading(false);
            showAlert(AlertType.Success, '', 'You have successfully updated CMS alignment data.');
          },
          errorBlock: (err) => {
            setIsLoading(false);
            showAlert(AlertType.Error, '', err);
          },
        },
      ),
    );
  };

  const { isEditMode, renderContent, setInitialData, setIsLoading, setIsEditMode, handleErrors } =
    useFormButtons(
      'section',
      setFormData,
      () => onSubmitHandler(setIsLoading, setIsEditMode, handleErrors),
      formData,
      true,
      'cms-alignment',
    );

  useEffect(() => {
    const data = getPatientCmsData(patient);
    setFormData(data);
    setInitialData(data);
  }, [JSON.stringify(getPatientCmsData(patient))]);

  const handleInputChange = (field, value) => {
    handleErrors(validatePatient(field, value));
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const renderForm = () => (
    <div className={styles.grid}>
      <Select
        id="nursing-home-status"
        label="Nursing home status"
        placeholder="Select"
        options={NursingHomeStatusOptions}
        onChange={(op) => handleInputChange('nursingHomeStatus', op.value)}
        value={NursingHomeStatusOptions.find((op) => op.value === formData.nursingHomeStatus)}
        size="small"
        readOnly={!isEditMode}
        position="absolute"
      />
      <Select
        id="residence-type"
        label="Residence type"
        placeholder="Select"
        options={ResidenceTypeOptions}
        onChange={(op) => handleInputChange('residenceType', op.value)}
        value={ResidenceTypeOptions.find((op) => op.value === formData.residenceType)}
        size="small"
        readOnly={!isEditMode}
        position="absolute"
      />
      <Select
        id="referral-source"
        label="Referral source"
        placeholder="Select"
        options={CmsReferralSourceOptions}
        onChange={(op) => handleInputChange('referralSource', op.value)}
        value={CmsReferralSourceOptions.find((op) => op.value === formData.referralSource)}
        size="small"
        readOnly={!isEditMode}
        position="absolute"
      />
    </div>
  );

  return (
    <>
      {renderForm()}
      {renderContent()}
    </>
  );
};

CmsAlignment.propTypes = {
  patient: PropTypes.exact(Patient.schema),
};

export default CmsAlignment;
